import styled from 'styled-components';
import { breakpoints, colors } from '@nextinq/ui-toolkit';
import { sizes } from '../../themes/sizes';

export const HEADER_HEIGHT = '48px';

export const HeroContainer = styled.section<{ minWidth?: string }>`
  display: grid;
  min-width: ${(p) => (p.minWidth ? p.minWidth : '320px')};
  height: calc(100vh - ${HEADER_HEIGHT});
  grid-template-rows: auto minmax(auto, 1fr) 2fr;
  padding: ${sizes.margins.massive};
  width: 100vw;
  max-width: ${breakpoints.max.tablet};
  align-items: center;
  justify-items: center;
  grid-gap: 2em;
  > h1,
  > h2,
  > h3 {
    text-align: center;
    color: ${colors.dark.primary};
  }
  @media ${breakpoints.max.smallPhone} {
    padding: 0;
  }
`;

export const AppContainer = styled.section`
  display: grid;
  width: 100vw;
  min-width: 320px;
  height: calc(100vh - ${HEADER_HEIGHT});
  max-width: ${breakpoints.max.tablet};
  align-items: start;
  justify-items: center;
`;

export const HeroHeader = styled.section`
  text-align: center;
  font-size: ${sizes.fonts.massive};
`;

export const HeroContent = styled.section`
  text-align: center;
  font-size: ${sizes.fonts.huge};
`;

export const AppContent = styled.section`
  display: grid;
  gap: ${sizes.margins.large};
`;

export const HeroFooter = styled.section`
  text-align: center;
  margin: 1em 0;
  font-size: ${sizes.fonts.massive};
  align-self: start;
`;
